<template>
  <carousel
    :data="data"
    :controls="false"
    indicator-type="disc"
    :slideOnSwipe="true"
  ></carousel>
</template>

<script>
import VueCarousel from "@chenfengyuan/vue-carousel";
export default {
  components: {
    carousel: VueCarousel
  },
  data() {
    return {
      data: [
        `<div class="w-full relative">
        <img
          class="object-cover w-full h-screen hidden lg:block"
          src="/img/YoungManSmiling.png"
          style="object-position: 80% 0%;"
        />
        <div
          class="absolute text-center text-white px-16 bottom-0 left-0 z-10 pt-20 pb-16"
          style="background-image: linear-gradient(to bottom, rgba(0,0,0,.01), rgba(0,0,0,.8));"
        >
          <h6 class="font-medium mb-2">No hazzles</h6>
          <p class="text-sm font-light">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod.
          </p>
        </div>
      </div>`,

        `<div class="w-full relative">
        <img
          class="object-cover w-full h-screen hidden lg:block"
          src="/img/YoungManSmiling.png"
          style="object-position: 80% 0%;"
        />
        <div
          class="absolute text-center text-white px-16 bottom-0 left-0 z-10 pt-20 pb-16"
          style="background-image: linear-gradient(to bottom, rgba(0,0,0,.01), rgba(0,0,0,.8));"
        >
          <h6 class="font-medium mb-2">No hazzles 2</h6>
          <p class="text-sm font-light">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod.
          </p>
        </div>
      </div>`
      ]
    };
  }
};
</script>

<style lang="css">
ol.carousel__indicators.carousel__indicators--disc {
  bottom: 20px;
}

.carousel__indicators--disc > .carousel__indicator {
  width: 0.75rem;
  margin: 0.125rem 0.2rem;
}

.carousel__indicators--disc
  li.carousel__indicator.carousel__indicator--active::before {
  background: #2bda53;
}

.carousel__indicators--disc
  li.carousel__indicator.carousel__indicator--active::after {
  border: 1px solid white;
  content: "";
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  height: 1rem;
  width: 1rem;
}
</style>
